import { FundViewOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

export const viewResultAction = () => {
    return (props) => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id } = params;
        const value = "viewResult";
        const label = "View the result";

        const navigate = useNavigate();
        const handleOnClick = () => {
            navigate(`view-result/${id}`);
            onClick(value);
        };
        return (
            <MenuItem
                key={value}
                value={value}
                label={label}
                icon={<FundViewOutlined sx={{ width: 16, height: 16 }} />}
                onClick={handleOnClick}
                {...restProps}
            >
                {label}
            </MenuItem>
        );
    };
};
